import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-3 md:px-6 py-6 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 mb-6 md:mb-12">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-1.5 md:gap-2 mb-2 md:mb-4">
              <img 
                src="https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/d573f1d2b846674670fcfa9ce25fd113.jpeg" 
                alt="GB Group Logo" 
                className="h-8 md:h-10 w-auto object-contain bg-white rounded px-1"
              />
              <span className="text-sm md:text-lg font-bold text-white whitespace-nowrap">GB Group</span>
            </div>
            <p className="text-[9px] md:text-sm mb-3 md:mb-6">
              {t('footer.description')}
            </p>
            <div className="flex gap-2 md:gap-4">
              <a href="#" className="w-6 h-6 md:w-8 md:h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xs md:text-base"></i>
              </a>
              <a href="#" className="w-6 h-6 md:w-8 md:h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xs md:text-base"></i>
              </a>
              <a href="#" className="w-6 h-6 md:w-8 md:h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xs md:text-base"></i>
              </a>
              <a href="#" className="w-6 h-6 md:w-8 md:h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xs md:text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xs md:text-base font-bold text-white mb-2 md:mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-1 md:space-y-2">
              <li>
                <Link to="/" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  {t('nav.products')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs md:text-base font-bold text-white mb-2 md:mb-4">{t('footer.categories')}</h3>
            <ul className="space-y-1 md:space-y-2">
              <li>
                <a href="#" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  Brake Systems
                </a>
              </li>
              <li>
                <a href="#" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  Suspension
                </a>
              </li>
              <li>
                <a href="#" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  Lighting
                </a>
              </li>
              <li>
                <a href="#" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  Electrical
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs md:text-base font-bold text-white mb-2 md:mb-4">{t('footer.support')}</h3>
            <ul className="space-y-1 md:space-y-2">
              <li>
                <a href="#" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  {t('footer.faq')}
                </a>
              </li>
              <li>
                <a href="#" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  {t('footer.shipping')}
                </a>
              </li>
              <li>
                <a href="#" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  {t('footer.returns')}
                </a>
              </li>
              <li>
                <Link to="/contact" className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-4 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 md:gap-4">
            <p className="text-[9px] md:text-sm text-center md:text-left">
              © 2024 GB Group. {t('footer.rights')}
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-[9px] md:text-sm hover:text-teal-400 transition-colors cursor-pointer"
              target="_blank"
              rel="noopener noreferrer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
